import React from 'react';
import Header from '../../components/header'
import Footer from '../../components/footer'
import CategoryBody from './body';


function Category() {
    document.title = `Yebokenny Business Categories`;
    return (
        <div>
            <Header></Header>
            <CategoryBody></CategoryBody>
            <Footer></Footer>
        </div>
    );
}

export default Category;